import {ref, onMounted, onUnmounted} from 'vue';

export function useOpacity() {
  const opacity = ref(0);

  onMounted(() => {
    const timer = setTimeout(() => {
      opacity.value = 1;
    }, 100);

    onUnmounted(() => {
      clearTimeout(timer);
    });
  });

  return opacity;
}
